import { Component } from "react";
import * as PropTypes from "prop-types";
import cx from "classnames";

export default class Popover extends Component {
  static propTypes = {
    className: PropTypes.string,
    visible: PropTypes.bool,
    text: PropTypes.string,
    content: PropTypes.node,
    position: PropTypes.string,
    onClick: PropTypes.func,
    minWidth: PropTypes.string
  };

  static defaultProps = {
    position: "bottom-left",
    minWidth: "120"
  };

  render() {
    const { className, visible, text, content, position, onClick, minWidth } =
      this.props;

    return (
      <div
        className={cx(
          "absolute w-auto z-[100]",
          "after:content-[''] after:w-0 after:h-0 after:absolute",
          visible ? "block z-[410]" : "hidden",
          position === "bottom-left" && [
            "pt-2 left-auto right-[-12px] top-full",
            "after:w-3 after:h-3 after:right-[14px] after:top-1 after:bg-white after:shadow-[-1px_-1px_0_#c4c8ca] after:rotate-45"
          ],
          position === "top-left" && [
            "pb-2 left-auto right-[-12px] bottom-full",
            "after:w-3 after:h-3 after:right-[14px] after:bottom-1 after:bg-white after:shadow-[-1px_-1px_0_#c4c8ca] after:-rotate-[135deg]"
          ],
          className
        )}
        style={{ minWidth: `${minWidth}px` }}
        onClick={onClick}
      >
        <div className="bg-white border border-gray-200 p-0 text-left rounded">
          {content || text}
        </div>
      </div>
    );
  }
}
